/** Tokens per ISO day, keyed for lookup. */
export function totalsByDay(series) {
  const map = new Map()
  for (const bucket of series ?? []) {
    map.set(String(bucket.bucket).slice(0, 10), Number(bucket.total_tokens) || 0)
  }
  return map
}

/**
 * Four intensity bands relative to the busiest day in the window.
 *
 * Relative rather than absolute: what counts as a heavy day differs wildly
 * between a trial tenant and a production one, and a fixed threshold would
 * render one of them as a flat grid.
 */
export function intensity(tokens, peak) {
  if (!tokens) return 0
  const share = tokens / peak
  if (share > 0.66) return 3
  if (share > 0.33) return 2
  return 1
}
